import React from "react";
import styled from "styled-components";

const MetamaskButton = styled.button`
  font-size: 1em;
  text-align: center;
  box-shadow: 0 3px 4px #ccc;
  border: 1px solid #eee;
  color: #555;
  padding: 8px 16px;
  background: white;
`;

const ConnectButton = (props) => (
  <div>
    <MetamaskButton onClick={props.onClick}>
      <img src="metamask-logo.png" alt="metamask logo" height="60px" />
      <br />
      <label>Metamask</label>
    </MetamaskButton>
  </div>
);

export default ConnectButton;
